import { IDashDetail } from "./dash-detail";
import { IDashListSummary } from "./dash-list-summary";
import { RestApi } from "@nkr/utils/rest-api";

export const DashRegistrationApi = new RestApi<IDashListSummary, IDashDetail>(`${__API__}/center/{centerId}/dash`)
    .makeHooks()
;